import DOMPurify from "dompurify";
import React from "react";
import { useLanguage } from "../../../context/LanguageContext";
import userImage3 from "../../../assets/images/user/user.png";

const BlogColumn = ({data}) => {
  const {language} = useLanguage();

  const sanitizedBody = DOMPurify.sanitize(data.body || "");
  const tagNames = data.tagNames ? [...data.tagNames] : [];
  return (
    <React.Fragment>
      <ul className="list-inline mb-0 mt-3 text-muted">
        <li className="list-inline-item">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <img
                src={userImage3}
                alt=""
                className="avatar-sm rounded-circle"
              />
            </div>
            <div className="ms-3">
              <h6 className="mb-0">
                {language === 'pt'
                  ? `Por ${data.author || data.bloggerName || "MobiSolutions"}`
                  : `By ${data.author || data.bloggerName || "MobiSolutions"}`}
              </h6>
            </div>
          </div>
        </li>
        <li className="list-inline-item">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className="uil uil-calendar-alt"></i>
            </div>
            <div className="ms-2">
              <p className="mb-0">
                {new Date(data.createdAt.split('.')[0]).toLocaleString(language === 'pt' ? "pt-PT" : "en-US", {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                })}
              </p>
            </div>
          </div>
        </li>
        <li className="list-inline-item">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className="uil uil-comments-alt"></i>
            </div>
            <div className="ms-2 flex-grow-1">
              <p className="mb-0">
                {language === 'pt'
                  ? `${data.commentCount ?? 0} Comentários`
                  : `${data.commentCount ?? 0} Comments`}
              </p>
            </div>
          </div>
        </li>
      </ul>
      <div className="mt-4">
        <h5>{data.title}</h5>
        <div
          className="text-muted mb-4 blog-body"
          dangerouslySetInnerHTML={{ __html: sanitizedBody }}
        />
        
        {tagNames.length > 0 && (
          <div className="d-flex align-items-center mb-4">
            <div className="flex-shrink-0">
              <b>Tags:</b>
            </div>
            <div className="flex-grow-1 ms-2 d-flex flex-wrap align-items-start gap-1">
              {tagNames.map((tag) => (
                <span
                  key={tag}
                  className="badge bg-success-subtle text-success mt-1 fs-14"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default BlogColumn;
